function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Third Party Imports
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group'; // Primary Imports

import InlineMessageStateless from './InlineMessageStateless';
import { MESSAGE_TYPE, TRANSITION_STATE, SETTINGS, inlineMessageUtil } from './utils/inlineMessageUtil'; // styles

import "./InlineMessage.css";

var InlineMessage = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InlineMessage, _Component);

  function InlineMessage(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var _this$props = _this.props,
        marginBottom = _this$props.marginBottom,
        marginTop = _this$props.marginTop,
        maxLineCount = _this$props.maxLineCount,
        message = _this$props.message,
        noAnimation = _this$props.noAnimation,
        type = _this$props.type;
    var adjType = inlineMessageUtil.getAdjustedType(message, type); // since this is based on props, it can be computed now

    var enterExitStyles = inlineMessageUtil.generateEnterExitStyles({
      mTop: marginTop,
      mBottom: marginBottom,
      maxLineCount: maxLineCount,
      noAnimation: noAnimation
    });
    var transitionState = adjType === MESSAGE_TYPE.NONE ? TRANSITION_STATE.EXITED : TRANSITION_STATE.ENTERED;
    _this.state = {
      animate: false,
      animationCounter: 0,
      animationType: {},
      enterExitStyles: enterExitStyles,
      message: message,
      prevMessage: message,
      prevType: adjType,
      shake: false,
      transitionState: transitionState,
      type: adjType
    }; // CSSTransition state change callbacks

    _this.onEnter = _this.onTransitionStateChange.bind(_assertThisInitialized(_this), TRANSITION_STATE.ENTER);
    _this.onEntering = _this.onTransitionStateChange.bind(_assertThisInitialized(_this), TRANSITION_STATE.ENTERING);
    _this.onEntered = _this.onTransitionStateChange.bind(_assertThisInitialized(_this), TRANSITION_STATE.ENTERED);
    _this.onExit = _this.onTransitionStateChange.bind(_assertThisInitialized(_this), TRANSITION_STATE.EXIT);
    _this.onExiting = _this.onTransitionStateChange.bind(_assertThisInitialized(_this), TRANSITION_STATE.EXITING);
    _this.onExited = _this.onTransitionStateChange.bind(_assertThisInitialized(_this), TRANSITION_STATE.EXITED);
    return _this;
  }

  var _proto = InlineMessage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // only trigger a new shake as the result of a mount,
    // ie. consumer should update "key" prop on <InlineMessage/>
    var shake = this.props.shake;

    if (shake) {
      this.setState({
        shake: shake,
        animationCounter: this.state.animationCounter + 1
      });
    }
  } // eslint-disable-next-line complexity
  ;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        animateIfJustMessageChanges = _this$props2.animateIfJustMessageChanges,
        marginBottom = _this$props2.marginBottom,
        marginTop = _this$props2.marginTop,
        maxLineCount = _this$props2.maxLineCount,
        message = _this$props2.message,
        noAnimation = _this$props2.noAnimation,
        type = _this$props2.type;
    var animationCounter = this.state.animationCounter; // handle triggering animation as a result of type or message changing.
    // since they are the result of a comparison between prevProps and this.props,
    // they should be triggered from componentDidUpdate because
    // prevProps is not available on componentDidMount or deriveStateFromProps

    var typeChanged = prevProps.type !== type;
    var messageChanged = prevProps.message !== message;

    if (typeChanged || messageChanged) {
      var adjType = inlineMessageUtil.getAdjustedType(message, type);
      var adjPrevType = inlineMessageUtil.getAdjustedType(prevProps.message, prevProps.type);
      var animate = typeChanged || messageChanged && animateIfJustMessageChanges;
      var animationType = inlineMessageUtil.computeAnimationType({
        type: adjType,
        prevType: adjPrevType,
        noAnimation: noAnimation
      });
      this.setState({
        animate: animate,
        animationCounter: animate ? animationCounter + 1 : animationCounter,
        animationType: animationType,
        message: message,
        prevMessage: prevProps.message,
        prevType: adjPrevType,
        shake: false,
        // only allow shake on mount; otherwise, set to false
        type: adjType
      });
    } // enterExitStyles are calculated in the constructor
    // and then again only if one of these props change:
    // marginTop, marginBottom, maxLineCount, noAnimation


    if (this.didChange(prevProps, this.props, ['marginTop', 'marginBottom', 'maxLineCount', 'noAnimation'])) {
      var enterExitStyles = inlineMessageUtil.generateEnterExitStyles({
        mTop: marginTop,
        mBottom: marginBottom,
        maxLineCount: maxLineCount,
        noAnimation: noAnimation
      });
      this.setState({
        enterExitStyles: enterExitStyles
      });
    }
  };

  _proto.didChange = function didChange(obj1, obj2, keyArray) {
    return keyArray.some(function (key) {
      return obj1[key] !== obj2[key];
    });
  };

  _proto.onTransitionStateChange = function onTransitionStateChange(transitionState) {
    if (this.state.transitionState !== transitionState) {
      this.setState({
        transitionState: transitionState
      });
    }
  };

  _proto.render = function render() {
    var _classnames;

    var _this$state = this.state,
        animate = _this$state.animate,
        animationCounter = _this$state.animationCounter,
        animationType = _this$state.animationType,
        message = _this$state.message,
        prevMessage = _this$state.prevMessage,
        prevType = _this$state.prevType,
        shake = _this$state.shake,
        transitionState = _this$state.transitionState,
        type = _this$state.type;
    var _this$props3 = this.props,
        inverse = _this$props3.inverse,
        noAnimation = _this$props3.noAnimation,
        id = _this$props3.id,
        className = _this$props3.className,
        ariaLive = _this$props3.ariaLive; // assign the correct margin, maxheight, etc based on whether component is entering or exiting

    var enterExitStyles = this.state.enterExitStyles[transitionState] || {};
    var rootClassNames = classnames('InlineMessage', (_classnames = {}, _classnames[className] = !!className, _classnames));
    return /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: "InlineMessage-CSSTransition",
      timeout: noAnimation ? 0 : SETTINGS.TRANSITION_DURATION,
      in: type !== MESSAGE_TYPE.NONE,
      mountOnEnter: true,
      unmountOnExit: true,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }, /*#__PURE__*/React.createElement("div", {
      className: rootClassNames,
      style: enterExitStyles
    }, /*#__PURE__*/React.createElement(InlineMessageStateless, {
      animate: animate,
      animationType: animationType,
      ariaLive: ariaLive,
      id: id,
      inverse: inverse,
      key: animationCounter,
      message: message,
      prevMessage: prevMessage,
      prevType: prevType,
      type: type,
      shake: shake,
      shakeTimeoutCallback: this.props.shakeTimeoutCallback
    })));
  };

  return InlineMessage;
}(Component);

InlineMessage.propTypes = {
  /** flag to animate if the type is the same but the message is different */
  animateIfJustMessageChanges: PropTypes.bool,

  /** The aria-live value for the alert.
   * 'polite' - indicates that the screen reader should wait until the user is idle before presenting updates to the user
   * 'assertive' may interupt user's flow
   */
  ariaLive: PropTypes.oneOf(['assertive', 'polite']),

  /** The message's id, required for a11y */
  id: PropTypes.string.isRequired,

  /** Flag to make message text use white text for better a11y contrast when used on dark backgrounds */
  inverse: PropTypes.bool,

  /** Unique identifier for a mounted instance of the component; to mount a new instance (eg. to trigger a new shake), pass a new key to the component */
  key: PropTypes.oneOf(['number', 'string']),

  /** The bottom margin. This is used to write the inline-style to enable the
   * transistion of this value (if maxLineCount > 0)*/
  marginBottom: PropTypes.number,

  /** The top margin. This is used to write the inline-style to enable the
   * transistion of this value (if maxLineCount > 0)*/
  marginTop: PropTypes.number,

  /** Max line count for expand/collapse transition. This is used to transition the max-height
   * css property of the component when entering or leaving the collapsed (aka 'none') state.
   * Setting this value to 0 makes this height transition immediate, and will accomodate
   * a message with any number of lines. When greater than 0, this value should always be
   * greater than or equal to the actual line count. The default value of 3, works for 1,
   * 2, and 3 lines messages with the only minor difference being the effective transition
   * duration and delay per line. Choose 6 if you have 4-6 lines, and if you have a message longer
   * than 6 lines, you probably need something other than the inline message. */
  maxLineCount: PropTypes.oneOf([0, 3, 6]),

  /** The content of the message */
  message: PropTypes.node,

  /** flag to disable all animation */
  noAnimation: PropTypes.bool,

  /** Should the message shake; should be passed in conjunction with a new key value to reset the component. */
  shake: PropTypes.bool,

  /** The type of message */
  type: PropTypes.oneOf(['help', 'info', 'warn', 'danger', 'success'])
};
InlineMessage.defaultProps = {
  animateIfJustMessageChanges: true,
  ariaLive: 'polite',
  inverse: false,
  marginBottom: 0,
  marginTop: 0,
  maxLineCount: 3,
  message: '',
  noAnimation: false,
  shake: false,
  type: 'help'
};
export default InlineMessage;
//# sourceMappingURL=InlineMessage.js.map